import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'
import type { components } from '../api/modelos'

export type Catalogos = components['schemas']['Catalogos']
export type OpcionFiltro = components['schemas']['OpcionFiltro']

/**
 * Catalogo de semanas y rutas para los desplegables. `staleTime: Infinity`
 * porque son cuatro semanas y cinco rutas fijas: no cambian durante una sesion
 * y revalidarlas seria una peticion gratuita en cada vuelta a la pagina.
 */
export function useFiltrosCatalogo() {
  const api = useApi()

  return useQuery<Catalogos, ErrorApi>({
    queryKey: ['filtros'],
    queryFn: ({ signal }) => api.pedir<Catalogos>('/api/filtros', { senal: signal }),
    staleTime: Number.POSITIVE_INFINITY,
  })
}
